import { CookiesController } from '../CookiesController.js';

class URLParamsController {
    static getURLParam(name) {
        const parameters = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (let i = 0; i < parameters.length; i++) {
            const parameterParts = parameters[i].split('=');
            if (parameterParts[0] === name) return parameterParts[1];
        }
        return '';
    }

    static getURLParamToCookie(parameterName, cookieName) {
        if (URLParamsController.getURLParam(parameterName) !== '') CookiesController.createCookie(cookieName, URLParamsController.getURLParam(parameterName), '2010-01-01');
    }

    static getURLParamToCookieWithDuration(parameterName, cookieName, seconds) {
        if (URLParamsController.getURLParam(parameterName) !== '') CookiesController.createCookieWithDuration(cookieName, URLParamsController.getURLParam(parameterName), seconds);
    }

    static getCookie(cookieName) {
        return CookiesController.readCookie(cookieName);
    }

    static init() {
        URLParamsController.getURLParamToCookie('utm_source', 'utm_source');
        URLParamsController.getURLParamToCookie('utm_medium', 'utm_medium');
        URLParamsController.getURLParamToCookie('utm_campaign', 'utm_campaign');
        URLParamsController.getURLParamToCookie('utm_term', 'utm_term');
        URLParamsController.getURLParamToCookie('utm_content', 'utm_content');
    }
}

window.URLParamsController = URLParamsController;
export default URLParamsController;

// #endregion
